module.exports = __webpack_public_path__ + "static/media/partner5.676b754f.png";